import { render, staticRenderFns } from "./enPreviewCourse.vue?vue&type=template&id=4ff2f984&scoped=true&"
import script from "./enPreviewCourse.vue?vue&type=script&lang=js&"
export * from "./enPreviewCourse.vue?vue&type=script&lang=js&"
import style0 from "./enPreviewCourse.vue?vue&type=style&index=0&id=4ff2f984&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff2f984",
  null
  
)

export default component.exports